import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from 'routes';
import { PublicLayout } from 'components/PublicLayout';
import { SetNewPasswordPage } from 'pages/SetNewPasswordPage';
import { BlankPage } from 'components/BlankPage';
import { SetNewPinNumberPage } from 'pages/SetPinPage';
import { RoleType } from '@higo/api/lib/models/roleType';
import { lazy, Suspense } from 'react';

const LazyPartnerModuleRouter = lazy(
  () => import('pages/Partner/PartnerModuleRouter'),
);

const LazySharedModuleRouter = lazy(
  () => import('pages/Shared/SharedModuleRouter'),
);

export const AppRouter = () => {
  return (
    <Suspense fallback={<>...</>}>
      <Routes>
        <Route path={routes.root} element={<PublicLayout />}>
          <Route path={routes.opsHealth} element={<BlankPage />} />
          <Route
            path={routes.setNewPassword}
            element={<SetNewPasswordPage />}
          />
          <Route
            path={routes.user.setPin}
            element={<SetNewPinNumberPage roleType={RoleType.User} />}
          />
          <Route
            path={routes.patient.setPin}
            element={<SetNewPinNumberPage roleType={RoleType.Patient} />}
          />
        </Route>

        <Route path={routes.shared.root} element={<LazySharedModuleRouter />} />
        <Route
          path={routes.partnerExam.root}
          element={<LazyPartnerModuleRouter />}
        />
        <Route
          path={routes.partnerVisit.root}
          element={<LazyPartnerModuleRouter />}
        />

        <Route path="*" element={<Navigate to={routes.root} replace />} />
      </Routes>
    </Suspense>
  );
};
